import { useState, useRef, useEffect } from "react";
import {
  InputGroup,
  InputLeftAddon,
  Input,
  InputRightElement,
  Button,
  Text,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { useSession } from "next-auth/react";
import { useDebouncedCallback } from "use-debounce";
import { searchPeople } from "controllers/list";
import { getAccount } from "utils/sessionHelper";
import { getFormattedContacts } from "./utils";
import { useSuggestions } from "components/suggestions/useSuggestions";
import { Suggestions } from "components/suggestions";
import { useOnClickOutside } from "utils/helpers";
import { textStyle } from "theme/names";

export function Url({ addPeople }) {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { data: session } = useSession() ?? {}
  const suggestionPopupRef = useRef(null);
  const inputRef = useRef(null);
  const {
    checkForSuggestions,
    suggestions,
    setSuggestions,
    isSuggestionsOpen,
    setIsSuggestionOpen,
    disableArrowKeys,
    updateText,
  } = useSuggestions(inputRef);

  // const debounced = useDebouncedCallback(checkForSuggestions, 400);

  // useOnClickOutside(suggestionPopupRef, async () => {
  //   await new Promise((resolve) => setTimeout(resolve, 200));
  //   setIsSuggestionOpen(false);
  // });

  const handleClick = async () => {
    if (!searchTerm) {
      toast.error(
        "Please enter a valid Handle or Profile url or Twitter list url"
      );
      return;
    }
    setIsLoading(true);
    const dataToSend: any = {
      idUser: getAccount(session)?.id,
      idLinkedin: getAccount(session)?.idLinkedin,
      from: "list",
      people: searchTerm,
    };

    const data = await searchPeople(session, dataToSend);
    setIsLoading(false);

    if (data?.success === 0) {
      toast.error(data.error);
      return;
    }

    const formattedList = getFormattedContacts(data.contacts);

    setSearchTerm("");
    addPeople(formattedList);
  };

  // const handleSelect = (handle: string) => {
  //   updateText(
  //     { currentText: searchTerm, handle, endWithSpace: false },
  //     (updatedText) => {
  //       setSearchTerm(updatedText);
  //     }
  //   );
  // };

  return (
    <Box mt="4">
      <Text
        textStyle={textStyle["h4.bold.standard"]}
        //  fontWeight="bold"
        // fontSize="lg"
      >
        Add a specific account
      </Text>
      <InputGroup size="md" w="466px" maxW="100%" mt="5">
        {/* <InputLeftAddon children="@" borderRadius="8px 0px 0px 8px" /> */}
        <Input
          value={searchTerm}
          ref={inputRef}
          pr="4.5rem"
          placeholder="Search username or paste account URL"
          borderRadius="lg"
          onChange={(e) => {
            const value = e.target.value;
            // if (value.length > 2) {
            //   debounced(e, "");
            //   setIsSuggestionOpen(true);
            // }
            setSearchTerm(value);
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleClick();
            }
          }}
          // onKeyUp={(e) => {
          //   if (e.keyCode === 27) {
          //     setIsSuggestionOpen(false);
          //     setSuggestions([]);
          //   }
          // }}
          // onKeyDown={disableArrowKeys}
          isDisabled={isLoading}
        />
        <InputRightElement width="4.5rem" onClick={handleClick}>
          <Button h="1.75rem" isLoading={isLoading} variant="primary">
            Add
          </Button>
        </InputRightElement>
        {/* {searchTerm && isSuggestionsOpen && suggestions.length > 0 && (
          <Box
            position="absolute"
            zIndex="popover"
            maxH="44"
            overflow="auto"
            background={useColorModeValue("white", "gray.800")}
            borderRadius="md"
            border="1px"
            boxShadow="md"
            width={{ base: "282px", sm: "352px" }}
            left="48px"
            borderColor="inherit"
            padding="1"
            top="110%"
            tabIndex={1}
            ref={suggestionPopupRef}
          >
            <Suggestions suggestions={suggestions} onSelect={handleSelect} />
          </Box>
        )} */}
      </InputGroup>
    </Box>
  );
}
